import { MapContainer, TileLayer, Marker, Popup } from "react-leaflet";
import { Icon } from "leaflet";
import "leaflet/dist/leaflet.css";
import "./styles.css";
import { UserProps } from "../../../controller/usersController";
import {
  SensorDataProps,
  TankDataProps,
} from "../../../controller/tankController";
import {
  MdOutlineWater,
  MdOutlineSensors,
  MdOutlineDateRange,
} from "react-icons/md";
import { FiVolume } from "react-icons/fi";
import { GiWaterTank, GiEnergyTank, GiFuelTank } from "react-icons/gi";
import { WiHumidity } from "react-icons/wi";
import { CiTempHigh } from "react-icons/ci";
import { TbWashTemperature3 } from "react-icons/tb";
import { TbBattery4 } from "react-icons/tb";
import { citiesInNigeria } from "../../../assets/SampleData/MapData";
import { formatTimeAgo } from "../../../hooks/updatedTime";

interface UserDetailsProps {
  showMoreDetails: boolean;
  setShowMoreDetails: (value: boolean) => void;
  userdetails: UserProps;
  tankData: TankDataProps;
  tankSensorData: SensorDataProps;
  tankId: string;
  tankSize: string;
}

function UserDetails({
  showMoreDetails,
  setShowMoreDetails,
  userdetails,
  tankData,
  tankSensorData,
  tankId,
  tankSize,
}: UserDetailsProps) {
  const locationIcon = new Icon({
    iconUrl: require("./map/img/map-icon.svg"),
    iconSize: [32, 32],
    iconAnchor: [16, 32],
  });

  const mapCoordinates =
    tankSensorData && tankSensorData.latitude && tankSensorData.longitude
      ? [
          parseFloat(tankSensorData.latitude),
          parseFloat(tankSensorData.longitude),
        ]
      : [48.8566, 2.3522];
  function getTankStatus(tankLevel: string | number | undefined): string {
    if (tankLevel === undefined) return "Nil";

    const level = Number(tankLevel);

    if (level < 40) return "Low";
    if (level >= 40 && level <= 50) return "Average";
    if (level > 50 && level <= 70) return "Moderate";
    if (level > 70) return "Good";

    return "Nil";
  }

  const currentLevel = Number(tankSensorData?.tankLevel);

  const TANK_HEIGHT = 110.3;
  const RADIUS = 38.3;
  const currentHeight = (currentLevel / 100) * TANK_HEIGHT;
  const currentVolume = (
    (Math.PI * Math.pow(RADIUS, 2) * currentHeight) /
    1000
  ).toFixed(1);
  return (
    <div className="bin-details-wrapper">
      <div className="bin-details" id="user-details">
        <div className="user-details-left">
          <MapContainer
            center={mapCoordinates as [number, number]}
            zoom={13}
            style={{ height: "100%" }}
          >
            <TileLayer
              attribution='&copy; <a href="https//www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
              url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
            />
            {tankSensorData &&
              tankSensorData.latitude &&
              tankSensorData.longitude && (
                <Marker
                  position={[
                    parseFloat(tankSensorData.latitude),
                    parseFloat(tankSensorData.longitude),
                  ]}
                  icon={locationIcon}
                >
                  <Popup>Tank {tankId}</Popup>
                </Marker>
              )}
            {/* Optional: Keep Nigeria city markers for reference */}
            {citiesInNigeria.map((city, index) => (
              <Marker
                key={index}
                position={city.coordinates}
                icon={locationIcon}
              >
                <Popup>{city.name}</Popup>
              </Marker>
            ))}
          </MapContainer>
        </div>
        <div className="user-details-right">
          <div className="close-div">
            <img
              src="./images/user/close.svg"
              alt="close"
              onClick={() => setShowMoreDetails(!showMoreDetails)}
            />
          </div>
          <div className="trash-div">
            <div className="trash-img">
              <img src="./images/tankdetails/tankstat.svg" alt="tank" />
            </div>
          </div>
          <div className="tankstat-div">
            <h3 className="stat-details">Status</h3>
            <div className="tantstat-cont">
              <div className="tankstat-details">
                <MdOutlineWater size={8} color="#6e9be3" />
                <p>
                  Diesel height:{" "}
                  {tankSensorData?.tankLevel
                    ? `${tankSensorData?.tankLevel}%`
                    : "Nil"}
                </p>
              </div>
              <div className="tankstat-details">
                <FiVolume size={8} color="#6e9be3" />
                <p>
                  Diesel volume:{" "}
                  {currentLevel ? `${currentVolume}Litres` : "Nil"}
                </p>
              </div>
              <div className="tankstat-details">
                <GiWaterTank size={8} color="#6e9be3" />
                <p>
                  Tank fullness:{" "}
                  {TANK_HEIGHT}Cm
                </p>
              </div>
              <div className="tankstat-details">
                <GiEnergyTank size={8} color="#6e9be3" />
                <p>
                  Tank status:{" "}
                  {tankSensorData?.tankLevel
                    ? getTankStatus(tankSensorData?.tankLevel)
                    : "Nil"}
                </p>
              </div>
              <div className="tankstat-details">
                <GiFuelTank size={8} color="#6e9be3" />
                <p>
                  Tank orientation:{" "}
                  {tankSensorData?.tankOrientation
                    ? `${tankSensorData?.tankOrientation}`
                    : "Nil"}
                </p>
              </div>
              <div className="tankstat-details">
                <TbWashTemperature3 size={8} color="#6e9be3" />
                <p>
                  Diesel temperature:{" "}
                  {tankSensorData?.waterTemperature
                    ? `${tankSensorData?.waterTemperature}cm`
                    : "Nil"}
                </p>
              </div>
              <div className="tankstat-details">
                <CiTempHigh size={8} color="#6e9be3" />
                <p>
                  Ambient temperature:{" "}
                  {tankSensorData?.ambientTemperature
                    ? `${tankSensorData?.ambientTemperature}cm`
                    : "Nil"}
                </p>
              </div>
              <div className="tankstat-details">
                <WiHumidity size={8} color="#6e9be3" />
                <p>
                  Ambient humidity:{" "}
                  {tankSensorData?.ambientHumidity
                    ? `${tankSensorData?.ambientHumidity}%`
                    : "Nil"}
                </p>
              </div>
              <div className="tankstat-details">
                <MdOutlineSensors size={8} color="#6e9be3" />
                <p>
                  Ultrasonic sensor status:{" "}
                  {tankSensorData?.sensorStatus
                    ? `${tankSensorData?.sensorStatus}cm`
                    : "Nil"}
                </p>
              </div>
              <div className="tankstat-details">
                <TbBattery4 size={8} color="#6e9be3" />
                <p>
                  Battery level:{" "}
                  {tankSensorData?.batteryLevel
                    ? `${tankSensorData?.batteryLevel}%`
                    : "Nil"}
                </p>
              </div>
              <div className="tankstat-details">
                <MdOutlineDateRange size={8} color="#6e9be3" />
                <p>Last Updated: {formatTimeAgo(tankSensorData?.createdAt)}</p>
              </div>
            </div>
          </div>
          <div className="user-full-details">
            <h3 className="stat-details">Details</h3>
            <div className="usertank-detais">
              <div className="user-details-con">
                <p className="details-title">First Name</p>
                <p className="details-des">{userdetails.firstName}</p>
              </div>
              <div className="user-details-con">
                <p className="details-title">Last Name</p>
                <p className="details-des">{userdetails.lastName}</p>
              </div>
              <div className="user-details-con">
                <p className="details-title">Email</p>
                <p className="details-des" id="usertank-email">
                  {userdetails.email}
                </p>
              </div>
              <div className="user-details-con">
                <p className="details-title">Phone Number</p>
                <p className="details-des">{userdetails.phoneNumber}</p>
              </div>
              <div className="user-details-con">
                <p className="details-title">Tank ID</p>
                <p className="details-des">{tankId}</p>
              </div>
              <div className="user-details-con">
                <p className="details-title">Tank Size</p>
                <p className="details-des">{tankSize}</p>
              </div>
              <div className="user-details-con">
                <p className="details-title">Tank Manufacture Date</p>
                <p className="details-des">
                  {tankData.manufactureDate || "N/A"}
                </p>
              </div>
              <div className="user-details-con">
                <p className="details-title">Address</p>
                <p className="details-des">{userdetails.address}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default UserDetails;
